import { defineStore } from 'pinia';
import { consola } from 'consola';
import { apiLoyalty } from '../api';
import { loyaltyUtils } from '../lib/loyaltyUtils'
import { useInstitutionStore } from '~/entities/institution/@x/loyalty';

const logger = consola.withTag('loyalty-store');

export const useLoyaltyStore = defineStore('loyalty', () => {
  const { setLoyaltyInfo } = loyaltyUtils();
  const institutionStore = useInstitutionStore();

  const loyaltyInfo = ref({
    points: 0,
    cashbackLevel: '3%',
    totalSpent: 0,
    pointsExpiryDate: null as string | null,
    daysUntilExpiry: 0,
    isExpiringSoon: false,
    expiryMessage: '',
    lifetimeSpent: 0,
    nextLevelInfo: {
      nextLevel: '',
      requiredSpent: 0,
      remainingToSpend: 0,
    },
  });

  const fetchLoyaltyInfo = async () => {
    try {
      // Бэк /loyalty/info требует institution_id (в JWT клиента его нет) —
      // без него 400 и баллы молча сбрасываются в 0. Прокидываем id заведения.
      const { data } = await apiLoyalty.getLoyaltyInfo(institutionStore.institution?.id);
      loyaltyInfo.value = {
        ...loyaltyInfo.value,
        ...setLoyaltyInfo(data),
        daysUntilExpiry: data.daysUntilExpiry || 0,
        isExpiringSoon: data.isExpiringSoon || false,
        expiryMessage: data.expiryMessage || '',
        nextLevelInfo: data.nextLevelInfo || {
          nextLevel: '',
          requiredSpent: 0,
          remainingToSpend: 0,
        },
      };
    } catch (error: any) {
      logger.warn('Не удалось получить информацию о баллах (не критично):', {
        message: error?.message || error,
        error,
      });
      loyaltyInfo.value = {
        points: 0,
        cashbackLevel: '3%',
        totalSpent: 0,
        pointsExpiryDate: null,
        daysUntilExpiry: 0,
        isExpiringSoon: false,
        expiryMessage: '',
        lifetimeSpent: 0,
        nextLevelInfo: { nextLevel: '', requiredSpent: 0, remainingToSpend: 0 },
      };
    }
  };

  const useLoyaltyPoints = async (orderId: number, pointsToUse: number) => {
    try {
      const response = await apiLoyalty.usePoints(orderId, pointsToUse);
      await fetchLoyaltyInfo();
      return response;
    } catch (error) {
      logger.error('Ошибка использования баллов:', error);
      throw error;
    }
  };

  const fetchLoyaltyHistory = async (page = 1, limit = 10) => {
    try {
      return await apiLoyalty.getLoyaltyHistory(page, limit);
    } catch (error) {
      logger.error('Ошибка получения истории баллов:', error);
      throw error;
    }
  };

  return { loyaltyInfo, fetchLoyaltyInfo, useLoyaltyPoints, fetchLoyaltyHistory };
});
